import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import './App.css';
import Router from './routes/Route';
import { LoaderProvider } from "./contexts/LoaderContext";

function App() {
  return (
    <>
      <LoaderProvider>
        <Router />
        <ToastContainer />
      </LoaderProvider>
    </>
  );
}
// Import components
// import Blogs from './components/AppComponents/Blogs';
// import AddBlog from './components/AppComponents/AddBlog';

// Routes array mein add karen
// {
//   path: '/blogs',
//   element: <Blogs />
// },
// {
//   path: '/add-blog',
//   element: <AddBlog />
// },
// {
//   path: '/edit-blog/:id',
//   element: <AddBlog /> // Same component for edit
// }
export default App;
